import React, { useState } from "react";
import { invNumber } from "../format";

function fmtDate(v) {
  return v ? new Date(v).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "—";
}

// Collapsible governance detail (owner / due / last computed / freshness / unresolved).
export default function InvestigationDetailsPanel({ inv, version, unresolved }) {
  const [open, setOpen] = useState(false);
  const rows = [
    ["Investigation", invNumber(inv)],
    ["Owner", inv?.ownerName || (inv?.ownerUserId ? `User ${inv.ownerUserId}` : "Unassigned")],
    ["Due", fmtDate(inv?.dueAt)],
    ["Last computed", version?.computedAt ? fmtDate(version.computedAt) : "not yet computed"],
    ["Unresolved ownership", unresolved ? `${unresolved.label}` : "None"],
  ];
  return (
    <div className="rounded-card border border-card-bd bg-card">
      <button type="button" onClick={() => setOpen((o) => !o)} className="flex w-full items-center justify-between px-5 py-3 text-[13px] font-medium text-text-2">
        <span>Investigation details</span>
        <span className="text-text-3">{open ? "▾" : "▸"}</span>
      </button>
      {open && (
        <dl className="grid grid-cols-2 gap-x-6 gap-y-2 border-t border-card-bd px-5 py-4 text-[13px] sm:grid-cols-3">
          {rows.map(([k, v]) => (
            <div key={k}>
              <dt className="text-[11px] uppercase tracking-wide text-text-3">{k}</dt>
              <dd className="tabular-nums text-text-2">{v}</dd>
            </div>
          ))}
        </dl>
      )}
    </div>
  );
}
